module.exports = __webpack_public_path__ + "static/net purpose-b19215f484cc4e83ef7faadf7a774f13.jpg";